import { z } from 'zod';

// Schema para Categoria de Produto
export const categoriaSchema = z.object({
  nome: z.string()
    .trim()
    .min(2, "Nome deve ter pelo menos 2 caracteres")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
});

// Schema para Tipo de Movimento
export const tipoMovimentoSchema = z.object({
  codigo: z.string()
    .trim()
    .min(1, "Código é obrigatório")
    .max(20, "Código deve ter no máximo 20 caracteres"),
  nome: z.string()
    .trim()
    .min(2, "Nome deve ter pelo menos 2 caracteres")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
  descricao: z.string().max(500, "Descrição deve ter no máximo 500 caracteres").optional(),
});

// Schema para Tipo de Documento
export const tipoDocumentoSchema = z.object({
  codigo: z.string()
    .trim()
    .min(1, "Código é obrigatório")
    .max(20, "Código deve ter no máximo 20 caracteres"),
  nome: z.string()
    .trim()
    .min(2, "Nome deve ter pelo menos 2 caracteres")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
  descricao: z.string().max(500, "Descrição deve ter no máximo 500 caracteres").optional(),
});

// Schema para Forma de Pagamento
export const formaPagamentoSchema = z.object({
  codigo: z.string()
    .trim()
    .min(1, "Código é obrigatório")
    .max(20, "Código deve ter no máximo 20 caracteres"),
  nome: z.string()
    .trim()
    .min(2, "Nome deve ter pelo menos 2 caracteres")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
  descricao: z.string().max(500, "Descrição deve ter no máximo 500 caracteres").optional(),
});

// Schema para Categoria de Receita
export const categoriaReceitaSchema = z.object({
  nome: z.string()
    .trim()
    .min(2, "Nome deve ter pelo menos 2 caracteres")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
  descricao: z.string().max(500, "Descrição deve ter no máximo 500 caracteres").optional(),
});

// Schema para Nível de Dificuldade
export const nivelDificuldadeSchema = z.object({
  codigo: z.string()
    .trim()
    .min(1, "Código é obrigatório")
    .max(20, "Código deve ter no máximo 20 caracteres"),
  nome: z.string()
    .trim()
    .min(2, "Nome deve ter pelo menos 2 caracteres")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
  descricao: z.string().max(500, "Descrição deve ter no máximo 500 caracteres").optional(),
});

// ==================== FORNECEDOR ====================
export const fornecedorSchema = z.object({
  nome: z.string().min(2, "Nome deve ter no mínimo 2 caracteres"),
  cnpj_cpf: z.string().optional().nullable(),
  telefone: z.string().optional().nullable(),
  email: z.string().optional().nullable().refine(
    (val) => !val || val === "" || z.string().email().safeParse(val).success,
    { message: "E-mail inválido" }
  ),
  endereco: z.string().optional().nullable(),
  observacoes: z.string().optional().nullable(),
});

export type FornecedorFormValues = z.infer<typeof fornecedorSchema>;

// ==================== MARCA ====================
export const marcaSchema = z.object({
  nome: z.string().min(2, "Nome deve ter no mínimo 2 caracteres"),
  descricao: z.string().optional().nullable(),
});

export type MarcaFormValues = z.infer<typeof marcaSchema>;
